/* Copyright 2019 Ellucian Company L.P. and its affiliates.
 * File: ISectionStatus.ts */

import { StatusLabelType } from '@hedtech/powercampus-design-system/react/core/StatusLabel';

export interface ISectionStatus {
    importantMessage?: string;
    labelText: string;
    labelType?: StatusLabelType;
    message?: string;
    status?: SectionStatus;
    statusIcon?: JSX.Element;
}

export enum SectionStatus {
    inCart,
    pending,
    registered,
    denied
}